import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function companyBusinessInquiry(token, params) {

    return Api.post(REQUEST_URLS.COMPANY_APPROVAL.BUSINESS_LICENSE_INQUIRY, params, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default companyBusinessInquiry;